import * as React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LinearProgress } from '@mui/material';

import { useSnackbar } from 'notistack';

import { useCreateNewFlightEvent } from '../../core/api/hooks/flight-event';
import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';

import { FlightEventFlightDetailsLookup, FlightEventReport, FlightLookup } from '../../core/api/clients';

import FlightLookupForm from '../../components/FlightLookupForm';
import FlightEventNewOptions from './FlightEventNewOptions';

function FlightEventFormNew() {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmit, setIsSubmit] = React.useState<boolean>(false);
  const [cssCreate, setCssCreate] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [flightSegments, setFlightSegments] = React.useState<FlightEventReport[]>([]);

  const authorizedFormData = useAuthorizedFormData();
  const { mutate: createFlightEvent, status: createFlightEventStatus } = useCreateNewFlightEvent();

  const handleCreateFlightEvent = (flightEventDetailsLookup: FlightEventFlightDetailsLookup) => {
    createFlightEvent(flightEventDetailsLookup, {
      onSuccess: (flightEventReports: FlightEventReport[]) => {
        if (flightEventReports.length === 1) {
          navigate(`${authorizedFormData.metadata?.route}/${flightEventReports[0].id}/edit`, { replace: true });
        } else {
          setFlightSegments(flightEventReports);
        }
      },
      onError: () => enqueueSnackbar('Flight not found', {
        variant: 'warning',
      }),
    });
  };

  React.useEffect(() => {
    if (searchParams.has('cssLegId')) {
      const cssLegId = searchParams.get('cssLegId');
      if (cssLegId !== null) {
        setCssCreate(true);
        handleCreateFlightEvent({ cssLegId });
      }
    }
  }, [searchParams]);

  const onSubmit = (flightLookup: FlightLookup) => {
    setIsSubmit(true);
    handleCreateFlightEvent({ flightLookup });
  };
  const onCancel = () => navigate(authorizedFormData.metadata?.route ?? '');
  const onBlank = () => {
    setIsSubmit(false);
    handleCreateFlightEvent({});
  };

  if (cssCreate && createFlightEventStatus === 'pending') {
    return (
      <LinearProgress />
    );
  }

  return (
    <React.Fragment>
      <FlightLookupForm
        onSubmit={onSubmit}
        onCancel={onCancel}
        onBlank={onBlank}
        color={authorizedFormData.metadata?.color}
        loading={isSubmit && createFlightEventStatus === 'pending'}
        isDateDefault
      />
      <FlightEventNewOptions
        data={flightSegments}
      />
    </React.Fragment>
  );
}

export default FlightEventFormNew;
